import { Component, OnInit } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-exam-history-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exam-history-view.component.html',
  styleUrls: ['./exam-history-view.component.scss']
})
export class ExamHistoryViewComponent implements OnInit {
  history: any[] = []; // Variável para armazenar o histórico

  constructor(private questionService: QuestionService) {}

  ngOnInit(): void {
    const userId = localStorage.getItem('id') || ''; // Recupera o id do usuário

    // Faz a chamada para buscar o histórico de exames
    this.questionService.getHistory(userId).subscribe(
      (data) => {
        this.history = data; // Armazena o retorno da requisição
      },
      (error) => {
        console.error('Erro ao carregar o histórico', error);
      }
    );
  }
}
